import { SongSection } from '../../services/composer/StructureEngine';

export interface SongStructureDefinition {
    name: string;
    description: string;
    sections: SongSection[];
    weight: number; // For probability (common vs exotic)
}

/**
 * A library of song structures to choose from.
 * Weighted to favor familiar forms while allowing for variation.
 */
export const SONG_STRUCTURES: SongStructureDefinition[] = [
    {
        name: 'Radio Hit',
        description: 'Classic Verse-Chorus structure',
        sections: ['Verse', 'Chorus', 'Verse', 'Chorus', 'Bridge', 'Chorus'],
        weight: 5
    },
    {
        name: 'Short & Sweet',
        description: 'Quick punchy pop song',
        sections: ['Verse', 'Chorus', 'Bridge', 'Chorus'],
        weight: 3
    },
    {
        name: 'Epic Journey',
        description: 'Long build-up with double bridge',
        sections: ['Verse', 'Verse', 'Chorus', 'Verse', 'Chorus', 'Bridge', 'Bridge', 'Chorus', 'Chorus'],
        weight: 2
    },
    {
        name: 'AABA Standard',
        description: 'Jazz/Golden Age form',
        sections: ['Verse', 'Verse', 'Bridge', 'Verse'],
        weight: 3
    },
    {
        name: 'Rondo',
        description: 'Chorus-focused circular form',
        sections: ['Chorus', 'Verse', 'Chorus', 'Bridge', 'Chorus'],
        weight: 2
    },
    {
        name: 'Slow Burn',
        description: 'Extended Verse development',
        sections: ['Verse', 'Verse', 'Verse', 'Chorus', 'Chorus'],
        weight: 2
    },
    {
        name: 'Double Header',
        description: 'Two verses before every chorus',
        sections: ['Verse', 'Verse', 'Chorus', 'Verse', 'Verse', 'Chorus', 'Bridge', 'Chorus'],
        weight: 2
    },
    {
        name: 'Through-Composed',
        description: 'Linear progression (concept)',
        sections: ['Verse', 'Verse', 'Bridge', 'Chorus', 'Bridge', 'Chorus'],
        weight: 1
    }
];

export function pickRandomStructure(): SongStructureDefinition {
    const totalWeight = SONG_STRUCTURES.reduce((sum, s) => sum + s.weight, 0);
    let random = Math.random() * totalWeight;

    for (const structure of SONG_STRUCTURES) {
        if (random < structure.weight) {
            return structure;
        }
        random -= structure.weight;
    }

    return SONG_STRUCTURES[0];
}
